import request from '@/utils/request'
// 产品指数
export function getPriceIndices() {
  return request({
    url: '/data/screen/priceIndices',
    method: 'get'
  })
}

// 产品排名
export function getIncreaseRanking() {
  return request({
    url: '/data/screen/increaseRanking',
    method: 'get'
  })
}

// 批发市场地图展示
export function getBazaarData(query) {
  return request({
    url: '/data/screen/bazaar',
    method: 'get',
    params: query
  })
}

// 批发市场最新报价
export function getOfferPrice() {
  return request({
    url: '/data/screen/offerPrice',
    method: 'get'
  })
}

// 农技课堂
export function getIotEduWikipedia(query) {
  const orgId = JSON.parse(localStorage.getItem("ui")).deptId;
  return request({
    url: '/EduWikipedia/getIotEduWikipedia',
    method: 'get',
    params: {
      ...query,
      orgId: orgId
    }
  })
}

// 病害列表
export function getDiseaseList(query) {
  const orgId = JSON.parse(localStorage.getItem("ui")).deptId;
  return request({
    url: `/fourmoodfile/getDiseaseInfo`,
    method: 'get',
    params: {
      orgId: orgId,
      ...query
    }
  })
}

// 虫害列表
export function getInsectList(query) {
  const orgId = JSON.parse(localStorage.getItem("ui")).deptId;
  return request({
    url: `/fourmoodfile/getIotBugsInfo`,
    method: 'get',
    params: {
      ...query,
      orgId: orgId
    }
  })
}

// 地块种植情况
export function getTotalData() {
  const orgId = JSON.parse(localStorage.getItem("ui")).deptId;
  return request({
    url: `/v1.0/${orgId}/farmland/farmland-statistics`,
    method: 'get',
  })
}


// 查询摄像头设备分页数据
export function getIotCamera() {
  const orgId = JSON.parse(localStorage.getItem("ui")).deptId;
  return request({
    url: '/revisepipe/IotCamera/IotCameraPage',
    method: 'get',
    params: {
      orgId: orgId
    }
  })
}

// 查询土地熵设备列表数据
export function getIotSoilsList() {
  const orgId = JSON.parse(localStorage.getItem("ui")).deptId;
  return request({
    url: '/devicepipe/IotSoils/page',
    method: 'get',
    params: {
      orgId: orgId
    }
  })
}

// 查询虫情设备列表数据
export function getIotBugMonitorList() {
  const orgId = JSON.parse(localStorage.getItem("ui")).deptId;
  return request({
    url: '/devicepipe/IotBugMonitor/page',
    method: 'get',
    params: {
      orgId: orgId
    }
  })
}

// 查询虫情/土地熵设备详情
export function getByIdAndType(query) {
  const orgId = JSON.parse(localStorage.getItem("ui")).deptId;
  return request({
    url: '/revisepipe/IotDevice/getByIdAndType',
    method: 'get',
    params: {
      orgId: orgId,
      ...query
    }
  })
}

// 作物品类占比 
export function getPercentageOfCropArea() {
  const orgId = JSON.parse(localStorage.getItem("ui")).deptId;
  return request({
    url: `/v1.0/${orgId}/crop/varieties-statistics`,
    method: 'get'
  })
}

// 查询地块下拉列表数据
export function getFarmlandList() {
  const orgId = JSON.parse(localStorage.getItem("ui")).deptId;
  return request({
    url: `/v1.0/${orgId}/farmland/list`,
    method: 'get',
    params: {}
  })
}

// 查询地块详情
export function getFarmlandDetail(query) {
  const orgId = JSON.parse(localStorage.getItem("ui")).deptId;
  return request({
    url: `/v1.0/${orgId}/farmland/${query}`,
    method: 'get',
    params: {}
  })
}

// 种植规模情况
export function getVarietiesScale() {
  const orgId = JSON.parse(localStorage.getItem("ui")).deptId;
  return request({
    url: `/v1.0/${orgId}/crop/varieties-scale-statistics`,
    method: 'get',
    params: {}
  })
}

// 农事农资用量统计数据
export function statisticsFarmLogs(query) {
  const orgId = JSON.parse(localStorage.getItem("ui")).deptId;
  return request({
    url: `/v1.0/${orgId}/farm-logs/agricultural-statistics-ratio`,
    method: 'get',
    params: query
  })
}

// 农资使用排行
export function statisticsFarmLogsTypeList(query) {
  const orgId = JSON.parse(localStorage.getItem("ui")).deptId;
  return request({
    url: `/v1.0/${orgId}/farm-logs/agricultural-use-statistics`,
    method: 'get',
    params: query
  })
}

// 加工阶段概况
export function getProcessRecordStage(query) {
  const orgId = JSON.parse(localStorage.getItem("ui")).deptId;
  return request({
    url: `/v1.0/${orgId}/process-record/state-statistics`,
    method: 'get',
    params: query
  })
}

// 加工记录趋势图
export function getRecordStatisticsTrend(query) {
  const orgId = JSON.parse(localStorage.getItem("ui")).deptId;
  return request({
    url: `/v1.0/${orgId}/process-record/record-statistics-trend`,
    method: 'get',
    params: query
  })
}

// 获取摄像头
export function getCameraLive(query) {
  return request({
    url: `/camera/live`,
    method: 'get',
    params: query
  })
}


// 虫情 查询最后一次记录
export function getLastData() {
  return request({
    url: `/devicepipe/getLastData`,
    method: 'get',
    params: {}
  })
}

// 摄像头统计
export function getLiveCount() {
  return request({
    url: `/camera/live/count`,
    method: 'get',
    params: {}
  })
}
